import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../Translations';
import AEPIcon from '../../../ExperienceCatalog/Experience/OfferingType/AppliedExperiencePlatform/AEPIcon';

interface Props {
  children?: React.ReactNode;
}

function AEPLabel({ children }: Props) {
  return (
    <div className="w-min flex items-center rounded-2xl border-teal-600 text-teal-600 px-3 py-1 text-xs border relative">
      <span className="mr-2">
        <AEPIcon />
      </span>
      <span className="mr-2">
        <T kind="ODL" />
      </span>
      {children}
    </div>
  );
}

export default observer(AEPLabel);
